import { apiGet, GetStatisticsRequest } from 'api';
import { StatisticsReport } from 'types';

export const getStatisticsReport = (
  request: GetStatisticsRequest
): Promise<StatisticsReport> =>
  apiGet<StatisticsReport, GetStatisticsRequest>('reports/stats', request);
